import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { InviteOrPassword, inviteToast } from "@/components/InviteOrPassword";
import { api, errMsg } from "@/lib/api";

const EMPTY = { name: "", admin_name: "", admin_email: "", admin_password: "" };

export const CreateCustomerDialog = ({ open, onOpenChange, onCreated }) => {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [invite, setInvite] = useState(true);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/admin/customers", { ...f, admin_password: invite ? null : f.admin_password });
      toast.success(`Kunden «${data.name}» er opprettet med standardtabeller`);
      if (invite) inviteToast(toast, f.admin_email, data.invite_sent);
      setF(EMPTY);
      onOpenChange(false);
      onCreated();
    } catch (ex) {
      toast.error(errMsg(ex));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="create-customer-dialog">
        <DialogHeader>
          <DialogTitle>Ny kunde</DialogTitle>
          <DialogDescription>Kunden får forhåndsutfylte tabeller for Farvannsavgift og Kaivederlag.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2"><Label>Havneterminal / kundenavn</Label><Input required value={f.name} onChange={set("name")} data-testid="new-customer-name" /></div>
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-2"><Label>Kontaktperson</Label><Input value={f.admin_name} onChange={set("admin_name")} data-testid="new-customer-admin-name" /></div>
            <div className="space-y-2"><Label>E-post (innlogging)</Label><Input type="email" required value={f.admin_email} onChange={set("admin_email")} data-testid="new-customer-admin-email" /></div>
          </div>
          <InviteOrPassword invite={invite} setInvite={setInvite} password={f.admin_password} setPassword={(v) => setF({ ...f, admin_password: v })} testPrefix="new-customer-admin" />
          <DialogFooter>
            <Button type="submit" disabled={busy} data-testid="create-customer-submit">{busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Opprett kunde</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
